<bn-loading-overlay></bn-loading-overlay>
<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>

<h5>SCR - Pesquisa de Operações</h5>

<div class="container" *ngIf="pesquisaForm; else carregando">

    <div class="mt-3 mx-auto">

        <div class="row">
            <div class="col">
                <h3>Filtros de pesquisa</h3>
            </div>

            <div class="col-auto">
                <button class="btn btn-primary no-margin" type="button" placement="bottom"
                    ngbTooltip="Tela para realizar a importação de arquivo mensal."
                    routerLink="/integracao/scr/importacao"
                    [disabled]="!podeEnviarScr">
                    Importar Arquivo
                </button>

            </div>

            <div class="col-auto">
                <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
            </div>

            <div class="col-auto">

                <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar()"
                    (click)="buscar()" [disabled]="!pesquisaForm.valid">Pesquisar
                </button>

            </div>
        </div>

        <div class="mt-3 row" [formGroup]="pesquisaForm" >

            <div class="bn-form-group col-md-3">
                <label for="janela">Data base: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                        ngbTooltip="Data base do arquivo enviado em formato Mês/Ano (MM/AAAA)"></i></label>
                <input type="text" class="form-control" bnMask="MESANO" formControlName="dataReferencia">
            </div>

            <div class="bn-form-group col-md-3">
                <label for="sistema">Ativo: </label>

                <select id="sistema" class="form-select" formControlName="ativo">
                    <option value='null'>Todos</option>
                    <option value='S'>Sim</option>
                    <option value='N'>Nao</option>
                </select>
            </div>
            
            <div class="bn-form-group col-md-3">
                <label for="Utilizado">Utilizado: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Arquivos Já utilizados na Crítica de Honra"></i></label>

                <select id="Utilizado" class="form-select" formControlName="foiUtilizadoNaCriticaDeHonra">
                    <option value='null'>Todos</option>
                    <option value='S'>Sim</option>
                    <option value='N'>Nao</option>
                </select>
            </div>

            <div *ngIf="0">    
                <div class="bn-form-group col-md-3">
                    <label for="dataCriacaoInicial">Data de publicação inicial:</label>
                    <bn-datepicker name="dataCriacaoInicial" idInput="dataCriacaoInicial" formControlName="dataCriacaoInicial"></bn-datepicker>
                </div>
                
                <div class="bn-form-group col-md-3">
                    <label for="dataCriacaoFinal">Data de publicação final:</label>
                    <bn-datepicker name="dataCriacaoFinal" idInput="dataCriacaoFinal" formControlName="dataCriacaoFinal">
                    </bn-datepicker>
                </div>
            </div>
                
        </div>

        <app-scr-listagem class="row" 
            *ngIf="pesquisado"
            [hidden]="esconderPesquisa"
            [scrs]="scrs" 
            [atributosPaginacao]="atributosPaginacaoComponenteListagem"
            (aoMudarPagina)="mudancaPagina($event)">
        </app-scr-listagem>
    </div>
</div>